// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const projectInfo = {
    "name": "elab-spa",
    "version": "1.14.0",
    "commitHash": "353657a412553c809d96a115f1129cf79e43615c",
    "gitBuildDate": "2026-11-04 19:37:24 +0000"
};
/* tslint:enable */
